import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { IconButton } from 'react-toolbox/lib/button';
import { Dialog, FontIcon } from 'react-toolbox';
import ReactTooltip from 'react-tooltip';
import UserNote from 'components/UserNote';
import S from 'modal.scss';
import styles from '../styles.scss';

class AppointmentNoteIndicator extends Component {
  state = {
    active: false,
  }

  toggleActive = () => this.setState({ active: !this.state.active });

  render() {
    const { active } = this.state;
    const { note, id } = this.props;
    return (
      <span>
        <FontIcon
          className={styles.noteIcon}
          value="note"
          data-tip
          data-for={`apptNote${id}`}
          onClick={this.toggleActive}
        />
        <ReactTooltip id={`apptNote${id}`} place="top" effect="solid">
          <span className={styles.tooltipText}>{note}</span>
        </ReactTooltip>
        {active && <Dialog
          active={active}
          className={S.modal}
          onEscKeyDown={this.toggleActive}
          onOverlayClick={this.toggleActive}
        >
          <IconButton icon="close" className={S.close} onClick={this.toggleActive} tabIndex={-1} />
          <h5 className={S.title}>Appointment Note</h5>
          <UserNote>{note}</UserNote>
        </Dialog>}
      </span>
    );
  }
}

AppointmentNoteIndicator.propTypes = {
  note: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
};

export default AppointmentNoteIndicator;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAppointments/components/appointmentNoteIndicator.jsx